import * as React from "react";
import { ImportesPPView } from "./view";
import * as models from "app/models/requireme";
import { createSelectorRx } from "keautils";
import * as resources from "app/resources/index";

interface Props {
    idTarifa: number;
    tipoServicio: models.TipoServicio;
    datosRef: models.DatosReferenciaTarifaPP;
}

function validarDatosRef(x: models.DatosReferenciaTarifaPP) {
    return (
        x.Alto != null &&
        x.Ancho != null &&
        x.Largo != null &&
        x.IdContenidoPaquete != null &&
        x.IdDescripcionPaquete != null &&
        x.IdSucursalDestino != null &&
        x.IdSucursalOrigen != null && 
        x.Peso != null && 
        x.ServiciosAdicionales != null
    );
}

function validarProps(x: Props) {
    return (
        x.idTarifa != null &&
        x.tipoServicio != null &&
        validarDatosRef(x.datosRef)
    )
}

export class ImportesPP extends React.PureComponent<Props> {
    idTarifa = (x: Props) => x.idTarifa;
    tipoServ = (x: Props) => x.tipoServicio;
    datosRef = (x: Props) => x.datosRef;
    valido= (x: Props) => validarProps(x);
    importes = createSelectorRx(this.idTarifa, this.tipoServ, this.datosRef, this.valido, (idTarifa, tipoServ, datosRef, val) =>
        val ?
        resources.TarifaPP.ObtenerImportes(idTarifa, tipoServ, models.TipoPersona.Fisica, datosRef) : 
        Promise.resolve(null)        
        );

    render() {
        const imps = this.importes(this.props);
        return <ImportesPPView value={imps} />;
    }
}


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/tarifapp/edit/importes/index.tsx